module.exports = __webpack_public_path__ + "static/img/register-l.8615ee4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/register-l.png
// module id = FG9X
// module chunks = 1